// bao migrate skip
import "./../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./bao-dialog";
class SendMailDialog {
    Email = ko.observable<string>("");
    ModelId: string;
    Parent : any;
    constructor(parent: any, modelId: string, email: string) {
        this.Parent = parent;
        this.ModelId = modelId;
    }
    ItemCompleteCheck() {
        return Boolean(this.Email().length > 0);
    }
    DialogWidth: number = 650;
    DialogHeight: number = 650;
    // TO DO: Wenn der fertige Bao-Email-Dialog da ist, diese Dialog-Funktionen zu einer machen und die unterschiedl. SendPdfMail-Funktionen als Variablen angeben
    DialogInstruction(): JQueryPromise<void> {
        return Bao.post("Instruction/InstructionSendMailDialog", JSON.stringify({}), (result) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            dialog.ViewModel(this);
            var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                if (this.ItemCompleteCheck()) {
                    this.SendPdfMailInstruction();
                    dialog.Close();
                }
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            dialog.Template(result.Template);
            dialog.Open(null);
            this.Parent.TabPage.IsLoading(false);
        });
    }
    SendPdfMailInstruction() {
        this.Parent.TabPage.IsLoading(true);
        return Bao.post("Instruction/PrintInfo", JSON.stringify({
            modelId: this.ModelId
        })).then((result) => {
            if (result.IsCreated == true) {
                //window.open(Bao.Content("BaoDocument/Download/" + result.Message), "_blank");         // zum Testen der Berichts-PDF
                Bao.post("Instruction/SendInstructionReportMail", JSON.stringify({
                    instructionId: this.ModelId,
                    tempDocId: result.Message,
                    emailAddress: this.Email()
                }), (result) => {
                    new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
                    this.Parent.TabPage.IsLoading(false);
                });
            }
            else if (result.IsCreated == false) {
                this.Parent.TabPage.IsLoading(false);
                new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    }
    DialogInformation(): JQueryPromise<void> {
        return Bao.post("Information/InformationSendMailDialog", JSON.stringify({}), (result) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            dialog.ViewModel(this);
            var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                if (this.ItemCompleteCheck()) {
                    this.SendPdfMailInformation();
                    dialog.Close();
                }
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            dialog.Template(result.Template);
            dialog.Open(null);
            this.Parent.TabPage.IsLoading(false);
        });
    }
    SendPdfMailInformation() {
        this.Parent.TabPage.IsLoading(true);
        return Bao.post("Information/PrintInfo", JSON.stringify({
            modelId: this.ModelId,
            reportId: this.Parent.ShiftReport.ReportId(),
            reportName: this.Parent.ShiftReport.ReportShortTitle()
        })).then((result) => {
            if (result.IsCreated == true) {
                // for testing output pdf
                // window.open(Bao.Content("BaoDocument/Download/" + result.Message), "_blank");
                Bao.post("Information/SendInfoReportMail", JSON.stringify({
                    tempDocId: result.Message,
                    emailAddress: this.Email(),
                    infoId: this.ModelId,
                    reportId: this.Parent.ShiftReport.ReportId()
                }), (result) => {
                    new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
                    this.Parent.TabPage.IsLoading(false);
                });
            }
            else if (result.IsCreated == false) {
                this.Parent.TabPage.IsLoading(false);
                new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    }
    DialogTask(): JQueryPromise<void> {
        return Bao.post("Task/TaskSendMailDialog", JSON.stringify({}), (result) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            dialog.ViewModel(this);
            var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                if (this.ItemCompleteCheck()) {
                    this.SendPdfMailTask();
                    dialog.Close();
                }
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            dialog.Template(result.Template);
            dialog.Open(null);
            this.Parent.TabPage.IsLoading(false);
        });
    }
    SendPdfMailTask() {
        this.Parent.TabPage.IsLoading(true);
        return Bao.post("Task/PrintInfo", JSON.stringify({
            modelId: this.ModelId
        })).then((result) => {
            if (result.IsCreated == true) {
                // for testing output pdf
                //  window.open(Bao.Content("BaoDocument/Download/" + result.Message), "_blank");
                Bao.post("Task/SendTaskReportMail", JSON.stringify({
                    tempDocId: result.Message,
                    emailAddress: this.Email(),
                    taskId: this.ModelId
                }), (result) => {
                    new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
                    this.Parent.TabPage.IsLoading(false);
                });
            }
            else if (result.IsCreated == false) {
                this.Parent.TabPage.IsLoading(false);
                new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    }
    DialogTicket(): JQueryPromise<void> {
        return Bao.post("Ticket/TicketSendMailDialog", JSON.stringify({}), (result) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            dialog.ViewModel(this);
            var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                if (this.ItemCompleteCheck()) {
                    this.SendPdfMailTicket();
                    dialog.Close();
                }
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            dialog.Template(result.Template);
            dialog.Open(null);
            this.Parent.TabPage.IsLoading(false);
        });
    }
    SendPdfMailTicket() {
        this.Parent.TabPage.IsLoading(true);
        return Bao.post("Ticket/CreateTicketReport", JSON.stringify({
            ticketId: this.ModelId
        })).then((result) => {
            if (result.IsCreated == true) {
                // for testing output pdf
                //  window.open(Bao.Content("BaoDocument/Download/" + result.Message), "_blank");
                Bao.post("Ticket/SendTicketReportMail", JSON.stringify({
                    tempDocId: result.Message,
                    emailAddress: this.Email(),
                    ticketId: this.ModelId
                }), (result) => {
                    new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
                    this.Parent.TabPage.IsLoading(false);
                });
            }
            else if (result.IsCreated == false) {
                this.Parent.TabPage.IsLoading(false);
                new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    }
}
export default SendMailDialog;